import { Component, Input, OnInit } from "@angular/core";
import { CustomColumnComponent, SharedModule } from "@bb-vendure/admin-ui/core";

@Component({
  imports: [SharedModule],
  selector: "product-type-column",
  templateUrl: "./product-type-column.component.html",
  standalone: true,
})
export class ProductTypeColumnComponent implements CustomColumnComponent {
  @Input() rowItem: { customFields: { productType: any } };
}
